<xpo-ngx-ltl-pickup-request
  *ngIf="pickupRequestComponentConfig"
  [pickupRequestComponentConfig]="pickupRequestComponentConfig"
></xpo-ngx-ltl-pickup-request>
